import { normalizeTemplateName } from 'modules/manager/domain/template-name-conflict';

/**
 * `suffix` — organization templates: a taken name gets «(импорт)», «(импорт 2)», …
 * `skip` — presets: a taken name means the preset is already there; `null`.
 */
export type ImportNameMode = 'suffix' | 'skip';

export function importNameCandidate(name: string, attempt: number): string {
  if (attempt === 0) return name;
  // eslint-disable-next-line lingui/no-unlocalized-strings -- сохраняется в имя шаблона в БД, а не подпись интерфейса
  if (attempt === 1) return `${name} (импорт)`;
  // eslint-disable-next-line lingui/no-unlocalized-strings -- сохраняется в имя шаблона в БД, а не подпись интерфейса
  return `${name} (импорт ${attempt})`;
}

/**
 * Picks the name to create the template under. `taken` holds names already
 * passed through `normalizeTemplateName` — the same comparison as the DB index.
 * A name the server rejected with 21409 although the cache said it was free goes
 * into `taken` too, and the next call moves past it.
 */
export function resolveImportName(name: string, taken: ReadonlySet<string>, mode: ImportNameMode): string | null {
  const trimmed = name.trim();
  if (mode === 'skip') {
    return taken.has(normalizeTemplateName(trimmed)) ? null : trimmed;
  }
  for (let attempt = 0; ; attempt += 1) {
    const candidate = importNameCandidate(trimmed, attempt);
    if (!taken.has(normalizeTemplateName(candidate))) return candidate;
  }
}
